import AuthSignUpForm from './Form'

const AuthSignUp = () => {
  return <AuthSignUpForm />
}

export default AuthSignUp
